import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function MechanismSection() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8
  }} className="py-16 lg:py-24 border-t border-[#1B6B3A]/10" data-id="element-73">
      <div className="bg-[#1A1A1A] text-[#FAFAF7] p-8 md:p-10 lg:p-14 rounded-xl shadow-2xl relative overflow-hidden" data-id="element-74">
        <div className="absolute top-0 right-0 w-48 h-48 bg-[#1B6B3A] opacity-20 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-75"></div>

        <h2 className="text-3xl lg:text-4xl font-serif font-bold mb-6 lg:mb-8 relative z-10" data-id="element-76">
          The Unique Mechanism: 7‑3‑1
        </h2>

        <p className="text-lg lg:text-xl text-gray-300 mb-6 lg:mb-8 relative z-10" data-id="element-77">
          Most buyers wait to be informed.
        </p>

        <p className="text-xl lg:text-2xl font-medium mb-8 lg:mb-10 relative z-10" data-id="element-78">
          This product makes you the person who confirms—on purpose—at:
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 relative z-10" data-id="element-79">
          {[{
          day: '7 days out',
          action: 'Catch missing inputs'
        }, {
          day: '3 days out',
          action: 'Force draft math'
        }, {
          day: '24 hours out',
          action: 'Lock final cash + secure wire confirmation'
        }].map((item, i) => <div key={i} className="flex lg:flex-col items-center lg:items-start gap-4 lg:gap-3 bg-white/5 p-4 lg:p-6 rounded-lg border border-white/10" data-id="element-80">
              <div className="bg-[#1B6B3A] px-3 py-2 lg:px-4 lg:py-2 rounded text-white font-bold whitespace-nowrap text-base lg:text-lg" data-id="element-81">
                {item.day}
              </div>
              <ArrowRight className="w-5 h-5 text-gray-400 flex-shrink-0 hidden md:block lg:hidden" data-id="element-82" />
              <span className="text-lg lg:text-xl font-medium text-[#FAFAF7]" data-id="element-83">
                {item.action}
              </span>
            </div>)}
        </div>
      </div>

      <div className="mt-16 lg:mt-20" data-id="element-84">
        <h3 className="text-2xl lg:text-3xl font-serif font-bold text-[#1A1A1A] mb-6 lg:mb-8" data-id="element-85">
          You'll know which "moving lines" matter:
        </h3>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5" data-id="element-86">
          {['Tax Escrow / Prorations', 'Homeowners Insurance Premium + Payment Method', 'HOA Transfer/Initiation Fees + Prorations', 'Prepaid Interest', 'Credits and Adjustments', 'Title/Attorney/Recording Fees'].map((item, i) => <div key={i} className="flex items-center gap-3 p-3 lg:p-4 border-b border-[#1B6B3A]/20" data-id="element-87">
              <div className="w-2 h-2 bg-[#1B6B3A] rounded-full flex-shrink-0" data-id="element-88"></div>
              <span className="text-base lg:text-lg text-[#3D3D3D]" data-id="element-89">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </motion.section>;
}